import { HeroContentSection, HeroContentWrapper } from "./HeroContent.styles";

const HeroContent = ({ content, contentRef }: any) => {
  return (
    <HeroContentSection ref={contentRef}>
      <HeroContentWrapper>
        <h2 dangerouslySetInnerHTML={{ __html: content }} />
      </HeroContentWrapper>
    </HeroContentSection>
  );
};

export default HeroContent;
